<div>
    <div class="row" style="background-color: #005274 !important; display: flex;">
        <div class="col-5" style="height: 64px;">
            <img src="../../../assets/images/nXpress.svg" alt="" style="height: 41px; width: 7vw; margin-top: 8px;">
        </div>
        <div class="col-3" style="display: flex;justify-content: center;align-items: center;">
            <label style="width: 17rem;color: white;margin-top: 9px;font-size: 23px;letter-spacing: 2px;letter-spacing: 2px; margin-right: 160px;">Pre Editor</label>
        </div>
        <div class="col" style="display: flex;justify-content: center;align-items: center;">
            <button type="button"  class="btn btn-success me-2" (click)="goBackToDashboard()">
                Log Out
            </button>
        </div>
    </div>


    <div class="row" style="height: 100px;">
        <div class="col" style="display: flex;justify-content: center;align-items: center;">
           <label class="articalcount-label">Artical Count</label>
           
        </div>
        <div class="col-6" style="display: flex;justify-content: end;align-items: center;">
            <input type="text" id="searchInput" placeholder="Search..." class="search-option"/>
        </div> 
      
       
    </div>

    <div class="row">
        <div class="col">
            <div style="width: 86%; margin-left: 150px; margin-top: 25px;">
                <ejs-grid>
                  <e-columns>
                      <e-column field='id' headerText='Sr.No' textAlign='center' width='40'>
                          
                      </e-column>
                      <e-column field='vendor' headerText='Status' width='40' class="headertestchange"></e-column>
                      <e-column field='ArticleId' headerText='Article ID' textAlign='center' format='C2'
                          width='40'>
                      </e-column>
                      <e-column field='EditorialReferenceCode' headerText='Referance No' textAlign='center'
                          format='yMd' width='60'>
                      </e-column>
                          <e-column field='JournalCode' headerText='Created On' textAlign='center' format='yMd'
                          width='50'>
                      </e-column>
                  </e-columns>
              </ejs-grid>
              </div>
        </div>
    </div>
</div>
